<template lang='pug'>
  .product-rating-rating.rateit(ref='rating' data-rateit-resetable='false' :data-rateit-readonly='readonly' :data-rateit-starwidth='width' :data-rateit-starheight='height' :data-rateit-value='rating' data-rateit-ispreset='true')
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 14.65
    },
    height: {
      type: Number,
      default: 12
    },
    readonly: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    rating () {
      this.$nextTick(() => {
        $(this.$refs.rating).rateit({ max: 5 })
        $(this.$refs.rating).rateit('value', this.rating)
      })
    }
  },

  mounted () {
    this.$nextTick(() => {
      $(this.$refs.rating).rateit({ max: 5 })
    })
  },

  methods: {
    reset () {
      $(this.$refs.rating).rateit('reset')
    }
  }
}
</script>
